/**
 * Check if every element in `elements` is present in `selected` by Id.
 */
export function isAllSelected(elements: any[], selected: any[]): boolean {
  if (!selected?.length || !elements?.length) return false;
  return elements.every(
    (el: any) => selected.some((sel: any) => sel.Id === el.Id),
  );
}

/**
 * Toggle select-all on a VariableList ref: if all selected — unselectAll, otherwise selectAll.
 */
export function toggleSelectAll(listRef: any, allSelected: boolean): void {
  if (!listRef) return;
  if (allSelected) {
    listRef.unselectAll();
  } else {
    listRef.selectAll();
  }
}
